import { Divider, Button, Select, Space, Tree, Spin, Alert } from "antd";
import { useEffect, useState } from "react";
import esriRequest from "@arcgis/core/request";
import { ServicesConfig } from "../../service/servicesConfig";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";



const VicaDownloads = ({ mapView }) => {


    const [provincias, setProvincias] = useState([]);
    const [municipiosHuesca, setMunicipiosHuesca] = useState([]);
    const [municipiosZaragoza, setMunicipiosZaragoza] = useState([]);
    const [municipiosTeruel, setMunicipiosTeruel] = useState([]);
    const [selectedProvincia, setSelectedProvincia] = useState("");
    const [selectedMunicipioCode, setSelectedMunicipioCode] = useState("");
    const [selectedMunicipioName, setSelectedMunicipioName] = useState("");
    const [descargando, setDescargando] = useState(null);
    const [errorDownloadZip, setErrorDownloadZip] = useState(null);
    const [errorDownloadExcel, setErrorDownloadExcel] = useState(false);
    const [errorDownloadReport, setErrorDownloadReport] = useState(false);
    const [errorDownloadSHP, setErrorDownloadSHP] = useState(false);


    const [expandedElements, setExpandedElements] = useState(['0-0-0']);
    const [checkedElements, setCheckedElements] = useState([]);
    const [selectedElements, setSelectedElements] = useState([]);
    const [autoExpandParent, setAutoExpandParent] = useState(true);

    const urlObject = {
        /*
        urlProvinciasMunicipios: "https://idearagon.aragon.es/servicios/rest/services/IAA/iaa_v4_sgv/MapServer/23/query",
        urlDescargarSHP: "https://idearagon.aragon.es/servicios/rest/services/IAA/IAA_GP/GPServer/DescargaEIEL/execute",
        urlDescargaCapaEDAR: "https://idearagon.aragon.es/servicios/rest/services/IAA/IAA_GP/GPServer/DescargaSelect/execute"
        */
        urlProvinciasMunicipios: "https://idearagon.aragon.es/servicios/rest/services/IAA/iaa_v4_sgv/MapServer/23/query",
        urlDescargarSHP: "https://idearagon.aragon.es/servicios/rest/services/IAA/IAA_GP/GPServer/DescargaEIEL/execute",
        urlDescargaCapaEDAR: "https://idearagon.aragon.es/servicios/rest/services/IAA/IAA_GP/GPServer/DescargaSelect/execute"
        }

    const onExpand = (expandedKeysValue) => {
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        setExpandedElements(expandedKeysValue);
        setAutoExpandParent(false);
    };

    /**
     * Funcion que ercoge los valores chequeados de la lista de capas, filtra los indices numéricos de las capas y
     * los fija como checkedElements
     * 
     * @param {*} checkedKeysValue 
     */
    const onCheck = (checkedKeysValue) => {
        //console.log('onCheck', checkedKeysValue);
        let validValues = checkedKeysValue.filter(value => !isNaN(value) ? true : false)
        console.log('validados', validValues)
        setCheckedElements(validValues);
    };

    const onSelect = (selectedKeysValue, info) => {
        console.log('onSelect', info);
        setSelectedElements(selectedKeysValue);
    };

    /**
     * Recoge y registra el indice numérico de la provincia seleccionada.
     * 
     * @param {*} value 
     */
    const onChangeProvincia = (value) => {
        console.log("provincia", value)
        setSelectedProvincia(value)
    };

    /**
     * Recoge y registra el índice numérico y el nombre del municipio seleccionado.
     * 
     * @param {*} value 
     * @param {*} municipio 
     */
    const onChangeMunicipio = (value, municipio) => {
        console.log("municipio", value)
        console.log("municipio", municipio)
        let municipioCode = value;
        let label = undefined;
        if (municipio) {
            municipioCode = municipio.value.slice(2);
            label = municipio.label
        }
        setSelectedMunicipioCode(municipioCode);
        setSelectedMunicipioName(label)
    };

    /**
     * Función que devuelve los municipios pertenecientes a una provincia dependiendo del id de provincia que ha recibido
     * 
     * @param {*} provincia 
     * @returns 
     */
    const opcionesMunicipios = (provincia) => {
        if (provincia == "22") {
            return municipiosHuesca;
        } else if (provincia == "50") {
            return municipiosZaragoza
        } else if (provincia == "44") {
            return municipiosTeruel;
        } else {
            return []
        }

    }

    // Filter `option.label` match the user type `input`
    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());


    const fijarCapas = (mapView) => {

        let objetoPrueba = [
            {
                title: 'Capas a descargar',
                key: '0-0-0',
                children: [
                    {
                        title: "EIEL ABASTECIMIENTO",
                        key: "18aa8a7ab49-layer-5",
                        children: [
                            {
                                title: "Captación",
                                key: 9
                            },
                            {
                                title: "Deposito",
                                key: 10
                            },
                            {
                                title: "Tratamiento",
                                key: 11
                            },
                            {
                                title: "Boca de riego",
                                key: 12
                            },
                            {
                                title: "Hidrante",
                                key: 13
                            },
                            {
                                title: "Llave de corte",
                                key: 14
                            },
                            {
                                title: "Conducción",
                                key: 15
                            },
                            {
                                title: "Distribución",
                                key: 16
                            }
                        ]
                    },
                    {
                        title: "EIEL SANEAMIENTO",
                        key: "18aa8a7ab46-layer-4",
                        children: [
                            {
                                title: "Depuradora",
                                key: 1
                            },
                            {
                                title: "Camara limpia",
                                key: 2
                            },
                            {
                                title: "Pozo",
                                key: 3
                            },
                            {
                                title: "Sumidero",
                                key: 4
                            },
                            {
                                title: "Colector",
                                key: 5
                            },
                            {
                                title: "Emisario",
                                key: 6
                            },
                            {
                                title: "Ramales",
                                key: 7
                            }
                        ]
                    }
                ]
            }
        ]

        /*let objectTree = [
            {
                title: 'Capas a descargar',
                key: '0-0-0',
                children: []
            }
        ]

        var rootLayer = mapView.map.layers

        rootLayer.forEach(function (layer) {
            if (layer.title == "EIEL ABASTECIMIENTO" || layer.title == "EIEL SANEAMIENTO") {
                let capa = {
                    title: layer.title,
                    key: layer.id,
                    children: []
                }

                //console.log("Nombre de la capa:", layer.title);
                //console.log("ID de la capa:", layer.id);
                // Obtén las subcapas de la capa raíz
                let sublayers = layer.sublayers;

                // Itera a través de las subcapas y haz lo que necesites con ellas
                sublayers.forEach(function (sublayer) {
                    let subcapa = {
                        title: sublayer.title,
                        key: sublayer.id,
                    }
                    capa.children.push(subcapa)
                    //console.log("Nombre de la subcapa:", sublayer.title);
                    //console.log("ID de la subcapa:", sublayer.id);
                });
                objectTree[0].children.push(capa)
            }

            // Puedes acceder a más propiedades y métodos de sublayer según tus necesidades
        });*/
        return objetoPrueba;

    }

    /**
     * Función que recoge y registra las provicincias y municipios devueltos por una petición al servidor de idearagon.
     */
    const cargarProvinciasMunicipios = () => {
        let provinciasObject = [
            {
                value: "22",
                label: "Huesca"
            },
            {
                value: "50",
                label: "Zaragoza"
            },
            {
                value: "44",
                label: "Teruel"
            }
        ]
        let url = urlObject.urlProvinciasMunicipios;

        let options = {
            responseType: "json",
            query: {
                f: "pjson",
                returnGeometry: false,
                outSR: 4326,
                where: "1=1",
                outFields: " C_MUNI_INE, D_MUNI_INE",
                orderByFields: "D_MUNI_INE"
            }
        }

        esriRequest(url, options)
            .then(function (response) {
                // The requested data
                let datos = response.data.features;
                let datosMunicipiosZGZ = []
                let datosMunicipiosHUES = []
                let datosMunicipiosTER = []

                //console.log('data', datos)
                datos.forEach(element => {
                    let code = element.attributes.C_MUNI_INE + ""
                    let name = element.attributes.D_MUNI_INE
                    if (code.slice(0, 2) == "22") {
                        datosMunicipiosHUES.push(
                            {
                                value: code,
                                label: name
                            }
                        )
                    }
                    if (code.slice(0, 2) == "50") {
                        datosMunicipiosZGZ.push(
                            {
                                value: code,
                                label: name
                            }
                        )
                    }
                    if (code.slice(0, 2) == "44") {
                        datosMunicipiosTER.push(
                            {
                                value: code,
                                label: name
                            }
                        )
                    }
                })
                setMunicipiosHuesca(datosMunicipiosHUES)
                setMunicipiosTeruel(datosMunicipiosTER)
                setMunicipiosZaragoza(datosMunicipiosZGZ)
                //console.log('longitud', datosMunicipiosHUES.length + datosMunicipiosTER.length + datosMunicipiosZGZ.length)

            })
            .catch((error) => console.log('error en la carga de provincias y municipios', error));;

        setProvincias(provinciasObject)
    }

    /**
     * Función que realiza la petición de un objeto proveniente de la url pasada como parámetro.
     * Se usa la url del objeto recuperado para hacer la descarga.
     * 
     * id_descarga es un parámetro que sirve para indicar que la descarga se está realizando o ha dado error.
     * 
     * @param {*} url 
     * @param {*} options 
     * @param {*} id_descarga 
     */
    const funcionDescarga = (url, options, id_descarga) => {
        setDescargando(id_descarga)
        console.log("url", url)
        esriRequest(url, options)
            .then(function (response) {
                console.log(response.data.results)
                window.location = response.data.results[0].value.url
                return "fin"
            })
            .then((data) => {
                if (data == 'fin')
                    setDescargando(null)
            })
            .catch((error) => {
                setDescargando(null)
                setErrorDownloadZip(id_descarga)
                console.log('error en la obtencion del url para descargar zip', error)
            })
    }

    /**
     * Función que realiza la descarga del SHP de las capas de un municipio en concreto.
     * Es necesario que el municipio y las capas estén seleccionadas.
     */
    const descargarSHP = () => {
        /**
         * https://idearagon.aragon.es/servicios/rest/services/IAA/IAA_GP/GPServer/DescargaEIEL/execute?
         * f=json&
         * User=descarga&
         * Password=descarga&
         * capas=1%2C2%2C3%2C4%2C5%2C6%2C7%2C8%2C10%2C11%2C12%2C13%2C14%2C15%2C16&
         * municipio=50001
         */
        if (selectedMunicipioCode && checkedElements.length > 0) {
            let url = urlObject.urlDescargarSHP

            console.log(checkedElements.join(','))
            console.log(selectedElements)
            console.log(selectedMunicipioCode)
            let options = {
                query: {
                    f: "json",
                    User: "descarga",
                    Password: "descarga",
                    capas: checkedElements.join(','),
                    municipio: selectedMunicipioCode
                }
            }
            funcionDescarga(url, options, 0);
        } else {
            setErrorDownloadSHP(true)
        }

    }

    /**
     * Datos cartograficos EDAR
     * 
     */

    //EDAR gestionadas IAA
    /**
     * https://idearagon.aragon.es/servicios/rest/services/IAA/IAA_GP/GPServer/DescargaSelect/execute?
     * f=json&
     * User=descarga&
     * Password=descarga&
     * capa=18&
     * OIDS=-1
     */

    //EDAR subencionadas IAA
    /**
     * https://idearagon.aragon.es/servicios/rest/services/IAA/IAA_GP/GPServer/DescargaSelect/execute?
     * f=json&
     * User=descarga&
     * Password=descarga&
     * capa=19&
     * OIDS=-1
     */

    //EDAR gestionadas Aytms.
    /**
     * https://idearagon.aragon.es/servicios/rest/services/IAA/IAA_GP/GPServer/DescargaSelect/execute?
     * f=json&
     * User=descarga&
     * Password=descarga&
     * capa=20&
     * OIDS=-1
     */

    //EDAR en construcción
    /**
     * https://idearagon.aragon.es/servicios/rest/services/IAA/IAA_GP/GPServer/DescargaSelect/execute?
     * f=json&
     * User=descarga&
     * Password=descarga&
     * capa=21&
     * OIDS=-1
     */

    /**
     * Descarga un zip que contienen la capa EDAR cuyo id es pasado como parámetro
     * 
     * @param {*} id 
     * @param {*} id_descarga 
     */
    const descargaCapaEDAR = (id, id_descarga) => {
        let url = urlObject.urlDescargaCapaEDAR

        let options = {
            query: {
                f: "json",
                User: "descarga",
                Password: "descarga",
                capa: id,
                OIDS: -1
            }
        }
        funcionDescarga(url, options, id_descarga)
    }


    /**
     * Función que sirve para descargar el report de inventario en PDF de un municipio seleccionado.
     */
    const descargarInventarioReport = () => {
        if (selectedMunicipioCode) {
            console.log(selectedMunicipioCode)
            window.open(ServicesConfig.getAbsoluteUrl() + "/report/inventario/" + selectedProvincia + "/" + selectedMunicipioCode + "/" + selectedMunicipioName)
        } else {
            setErrorDownloadReport(true)
        }

    }

    /**
     * Función que sirve para descargar el report de datos en PDF de un municipio seleccionado.
     */
    const descargarDatosReport = () => {
        console.log(selectedMunicipioCode)
        if (selectedMunicipioCode) {
            window.open(ServicesConfig.getAbsoluteUrl() + "/report/datos/" + selectedProvincia + "/" + selectedMunicipioCode + "/" + selectedMunicipioName);
        } else {
            setErrorDownloadReport(true)
        }
    }

    /**
     * Función que sirve para descargar un fichero excel con los datos de las capas seleccionadas y el municipio seleccionado
     */
    const descargarExcel = () => {
        if (selectedMunicipioCode && checkedElements.length > 0) {
            window.open(ServicesConfig.getAbsoluteUrl() + "/report/excel/" + checkedElements.join(',') + "/" + selectedProvincia + "/" + selectedMunicipioCode + "/" + selectedMunicipioName)
        } else {
            console.log("error")
            setErrorDownloadExcel(true)
        }
    }

    /**
     * Función que devuelve una pieza de HTML con el error en la descarga del zip.
     * 
     * @returns 
     */
    const errorDescargaHTML = () => {
        return (<Alert
            message="Error"
            description="Fallo al descargar el archivo zip."
            type="error"
            closable
            onClose={setErrorDownloadZip(false)}
        />);
    }

    /**
     * Función que devuelve una pieza de HTML con el error en la descarga del excel.
     * 
     * @returns 
     */
    const errorDescargaExcel = () => {
        return (<Alert
            message="Error"
            description="Error. Selecciona municipio y capas."
            type="error"
            closable
            onClose={() => setErrorDownloadExcel(false)}
        />);
    }

    /**
     * Función que devuelve una pieza de HTML con el error en la descarga del SHP.
     * 
     * @returns 
     */
    const errorDescargaSHP = () => {
        return (<Alert
            message="Error"
            description="Error. Selecciona municipio y capas."
            type="error"
            closable
            onClose={() => setErrorDownloadSHP(false)}
        />);
    }

    /**
     * Función que devuelve una pieza de HTML con el error en la descarga del PDF report.
     * 
     * @returns 
     */
    const errorDescargaReport = () => {
        return (<Alert
            message="Error"
            description="Error. Selecciona municipio."
            type="error"
            closable
            onClose={() => setErrorDownloadReport(false)}
        />);
    }

    /**
     * Función que devuelve un spin cuando se está realizando la descarga.
     * 
     * @returns 
     */
    const descargandoHTML = () => {
        return (<Space>
            <Spin /> <p>DESCARGANDO...</p>
        </Space>);
    }


    useEffect(() => {
        cargarProvinciasMunicipios();
    }, [])

    return (
        <>
            <h3>Seleccione municipio</h3>

            <Space direction="vertical" style={{width: "100%"}}>
                <Select
                    showSearch
                    style={{width: "100%"}}
                    allowClear={true}
                    placeholder="Selecciona la provincia  "
                    onChange={onChangeProvincia}
                    filterOption={filterOption}
                    options={provincias}
                />
                <Select
                    showSearch
                    style={{width: "100%"}}
                    allowClear={true}
                    placeholder="Selecciona el municipio"
                    onChange={onChangeMunicipio}
                    filterOption={filterOption}
                    options={opcionesMunicipios(selectedProvincia)}
                />
            </Space>

            <Divider />
            <h3>Datos cartográficos EIEL por municipio</h3>
            <p>Los ficheros cartográficos descargados en formato Shapefile se encuentran en proyección ETRS89 Huso 30</p>
            <Space direction="vertical">
                <Tree
                    checkable
                    onExpand={onExpand}
                    expandedKeys={expandedElements}
                    autoExpandParent={autoExpandParent}
                    onCheck={onCheck}
                    checkedKeys={checkedElements}
                    onSelect={onSelect}
                    selectedKeys={selectedElements}
                    treeData={fijarCapas(mapView)}
                />
                {
                    descargando == 0 && descargandoHTML()
                }
                {
                    errorDownloadZip == 0 && errorDescargaHTML()
                }

            </Space>
            <br />
            <br />
            <Space direction="vertical">
                <Space>
                    <Button type="primary" onClick={(e) => {descargarSHP()}}>
                        Descargar SHP
                    </Button>
                    <Button type="primary" onClick={() => descargarExcel()}>
                        Descargar XLS
                    </Button>
                </Space>
                {
                    errorDownloadSHP && errorDescargaSHP()
                }
                {
                    errorDownloadExcel && errorDescargaExcel()
                }
            </Space>
            <Divider />
            <h3>Informes EIEL PDF</h3>
            <p>Informe con el resumen de elementos de la EIEL en formato PDF</p>
            <Button type="primary" onClick={() => descargarInventarioReport()}>
                Descargar inventario municipio
            </Button>
            <p>Informe con los datos de todos los elementos de la EIEL en formato PDF</p>
            <Button type="primary" onClick={() => descargarDatosReport()}>
                Descargar datos municipio
            </Button>
            {
                errorDownloadReport && errorDescargaReport()
            }
            <Divider />
            <h3>Datos cartográficos EDAR</h3>
            <Space direction="vertical">
                <p>Descarga de EDARs gestionadas por el IAA en servicio de todo Aragón, en formato Shapefile y proyección ETRS89 Huso 30.</p>
                {
                    descargando == 1 && descargandoHTML()
                }
                {
                    errorDownloadZip == 1 && errorDescargaHTML()
                }
            </Space>

            <Button type="primary" onClick={(e) => descargaCapaEDAR("18", 1)}>
                EDARs gestionadas IAA
            </Button>
            <Space direction="vertical">
                <p>Descarga de EDARs subvencionadas por el IAA en servicio de todo Aragón, en formato Shapefile y proyección ETRS89 Huso 30.</p>
                {
                    descargando == 2 && descargandoHTML()
                }
                {
                    errorDownloadZip == 2 && errorDescargaHTML()
                }
            </Space>

            <Button type="primary" onClick={(e) => descargaCapaEDAR("19", 2)}>
                EDARs subvencionadas IAA
            </Button>
            <Space direction="vertical">
                <p>Descarga de EDARs gestionaas por Ayuntamientos en servicio de todo Aragón, en formato Shapefile y proyección ETRS89 Huso 30.</p>
                {
                    descargando == 3 && descargandoHTML()
                }
                {
                    errorDownloadZip == 3 && errorDescargaHTML()
                }
            </Space>

            <Button type="primary" onClick={(e) => descargaCapaEDAR("20", 3)}>
                EDARs gestionadas Aytos.
            </Button>
            <Space direction="vertical">
                <p>Descarga de EDARs en construcción de todo Aragón, en formato Shapefile y proyección ETRS89 Huso 30.</p>
                {
                    descargando == 4 && descargandoHTML()
                }
                {
                    errorDownloadZip == 4 && errorDescargaHTML()
                }
            </Space>

            <Button type="primary" onClick={(e) => descargaCapaEDAR("21", 4)}>
                EDARs en construcción
            </Button>
        </>
    );
}

export default VicaDownloads;